import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss']
})
export class TrackComponent implements OnInit, OnDestroy {

  private unsubscribe: Subject<void> = new Subject();
  public track: any;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.data
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({track}: { track: any }) => {
        if (track) {
          this.track = track;
          //console.log(track);
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/components/track/track.component.ts